import ErrorComponent from "components/shared/ErrorComponent";
import Loader from "components/shared/Loader";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useFetchContentQuery } from "store/services/user.service";

const PrivacyPolicy = () => {
  const { data: privacyContent, isLoading, isError } = useFetchContentQuery("PRIVACY_POLICY");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (privacyContent) {
      setContent(privacyContent.content);
    }
  }, [privacyContent]);

  return (
    <div className="inner">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ): isError ? (
            <ErrorComponent />
          ):(
            <div className="contentSec">
              <div
                className="m-0 text-muted py-2"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PrivacyPolicy;
